/**
 * Trishul Tours & Travels — Master Route Inventory & Content Repository
 * 48 Approved Origin-Destination Combinations across Vapi, Bhilad, Daman, Silvassa, Valsad, and Umbergaon.
 * Factual, route-specific data with zero invented pricing or travel guarantees.
 */

export const approvedOrigins = [
  { id: 'vapi', name: 'Vapi', district: 'Valsad', state: 'Gujarat', hubs: ['Vapi Railway Station', 'GIDC Phase 1-4', 'Gunjan', 'Charwada', 'Chala', 'Chanod Colony', 'Daman Road'] },
  { id: 'bhilad', name: 'Bhilad', district: 'Valsad', state: 'Gujarat', hubs: ['Bhilad Railway Station', 'Sarigam GIDC Junction', 'Bhilad Checkpost', 'NH 48 Flyover'] },
  { id: 'daman', name: 'Daman', district: 'Daman', state: 'DNH & DD', hubs: ['Nani Daman', 'Moti Daman', 'Devka Beach', 'Jampore Beach', 'Daman GIDC'] },
  { id: 'silvassa', name: 'Silvassa', district: 'Dadra & Nagar Haveli', state: 'DNH & DD', hubs: ['Silvassa Bus Stand', 'Piparia Industrial Estate', 'Naroli', 'Sayli', 'Tokarkhada', 'Samarvarni'] },
  { id: 'valsad', name: 'Valsad', district: 'Valsad', state: 'Gujarat', hubs: ['Valsad Railway Station', 'Dharampur Road', 'Tithal Beach Road', 'Gundlav GIDC', 'Kapadia Chal'] },
  { id: 'umbergaon', name: 'Umbergaon', district: 'Valsad', state: 'Gujarat', hubs: ['Umbergaon GIDC', 'Umbergaon Town', 'Sanjan Road', 'Deheri Beach', 'Station Road'] }
];

export const approvedDestinations = [
  {
    id: 'mumbai-airport',
    name: 'Mumbai Airport',
    fullName: 'Chhatrapati Shivaji Maharaj International Airport (BOM), Mumbai',
    city: 'Mumbai',
    category: 'Airport Transfer',
    dropPoints: ['Terminal 1 (Domestic, Santacruz)', 'Terminal 2 (International & Domestic, Sahar)', 'Sahar Cargo Complex', 'Airport Hotels & Vile Parle'],
    routeVia: 'NH 48 (Western Express Highway) via Manor, Ghodbunder / Dahisar Toll Plaza',
    tollParkingPolicy: 'Highway tolls and airport terminal parking fees are charged transparently at actuals or quoted all-inclusive upfront.'
  },
  {
    id: 'surat',
    name: 'Surat',
    fullName: 'Surat City & Surat Airport (STV)',
    city: 'Surat',
    category: 'Commercial & Industrial Hub',
    dropPoints: ['Surat Airport (STV), Magdalla', 'Surat Railway Station', 'Ring Road Textile Market', 'Varachha Diamond Market', 'Hazira Industrial Belt', 'Adajan & Vesu'],
    routeVia: 'NH 48 (Delhi-Mumbai Highway) via Valsad, Navsari, and Sachin',
    tollParkingPolicy: 'State highway and NH 48 tolls are billed at actuals or bundled into our all-inclusive outstation quote.'
  },
  {
    id: 'ahmedabad',
    name: 'Ahmedabad',
    fullName: 'Ahmedabad City & Sardar Vallabhbhai Patel International Airport (AMD)',
    city: 'Ahmedabad',
    category: 'Commercial Capital & Airport Hub',
    dropPoints: ['Sardar Vallabhbhai Patel Airport (AMD)', 'Kalupur Railway Station', 'SG Highway', 'Prahlad Nagar & Satellite', 'GIFT City / Gandhinagar', 'Sanand GIDC'],
    routeVia: 'NH 48 expressway corridor via Navsari, Surat, Bharuch, Vadodara, and NE1 (Ahmedabad-Vadodara Expressway)',
    tollParkingPolicy: 'NE1 expressway toll and NHAI tolls are clearly itemized in your live booking fare summary.'
  },
  {
    id: 'igatpuri',
    name: 'Igatpuri',
    fullName: 'Igatpuri Hill Station & Vipassana Centre',
    city: 'Igatpuri',
    category: 'Western Ghats / Hill Station',
    dropPoints: ['Dhamma Giri Vipassana International Academy', 'Bhavali Dam & Waterfalls', 'Manas Resort / Camel Valley', 'Igatpuri Railway Station', 'Kasara Ghat Viewpoint'],
    routeVia: 'NH 848 / NH 48 via Jawhar-Mokhada or Manor-Wada-Bhiwandi-Shahapur corridor',
    tollParkingPolicy: 'Ghat section toll booths and parking fees at tourist sites are paid at actuals.'
  },
  {
    id: 'malshej-ghat',
    name: 'Malshej Ghat',
    fullName: 'Malshej Ghat Western Ghats Pass',
    city: 'Malshej Ghat',
    category: 'Monsoon Nature & Mountain Pass',
    dropPoints: ['Malshej Ghat Viewpoint', 'MTDC Malshej Resort', 'Pimpalgaon Joga Dam', 'Anerdam Waterfall Area', 'Harishchandragad Base'],
    routeVia: 'NH 48 to Bhiwandi / Kalyan corridor connecting to NH 61 (Kalyan-Ahmednagar Highway) via Murbad',
    tollParkingPolicy: 'State highway tolls and forest/tourism entry charges are transparently accounted for on your itinerary.'
  },
  {
    id: 'kalu-waterfall',
    name: 'Kalu Waterfall',
    fullName: 'Kalu Waterfall (Malshej Ghat Region)',
    city: 'Kalu Waterfall',
    category: 'Nature, Trekking & Adventure',
    dropPoints: ['Khireshwar Village Trek Base', 'Kalu Waterfall Trailhead', 'Thitabi Village Entry Point', 'Malshej Pass Crossing'],
    routeVia: 'NH 48 toward Kalyan bypass and NH 61 up into the Western Ghats range towards Khireshwar',
    tollParkingPolicy: 'Rural parking, eco-tourism fees, and highway toll receipts are provided transparently.'
  },
  {
    id: 'nashik',
    name: 'Nashik',
    fullName: 'Nashik City, Trimbakeshwar & Wine Region',
    city: 'Nashik',
    category: 'Pilgrimage, Wine & Industrial City',
    dropPoints: ['Trimbakeshwar Shiva Jyotirlinga Temple', 'Sula Vineyards & Gangapur Dam', 'Panchavati & Godavari Ghats', 'Satpur & Ambad MIDC', 'Nashik Road Railway Station'],
    routeVia: 'Gujarat-Maharashtra State Highway 5 / NH 848 via Dharampur, Kaprada, Peint or via Manor-Jawhar-Trimbak route',
    tollParkingPolicy: 'Inter-state permit taxes (if applicable), toll plazas and temple parking are itemized upfront.'
  },
  {
    id: 'vadodara',
    name: 'Vadodara',
    fullName: 'Vadodara (Baroda) City & Vadodara Airport (BDQ)',
    city: 'Vadodara',
    category: 'Cultural & Industrial Capital',
    dropPoints: ['Vadodara Airport (BDQ), Harni', 'Vadodara Junction Railway Station', 'Laxmi Vilas Palace', 'Alkapuri & Sayajigunj', 'Makarpura GIDC & Nandesari Industrial Estate'],
    routeVia: 'NH 48 6-lane national highway via Valsad, Navsari, Surat bypass, Ankleshwar, and Bharuch Narmada Bridge',
    tollParkingPolicy: 'NHAI highway toll charges and parking receipts are shared directly with the passenger.'
  },
  {
    id: 'pune',
    name: 'Pune',
    fullName: 'Pune City, IT Corridors & Pune Airport (PNQ)',
    city: 'Pune',
    category: 'IT Capital & Education Hub',
    dropPoints: ['Hinjewadi Infotech Park (Phase 1, 2, 3)', 'Pune Airport (PNQ), Lohegaon', 'Shivaji Nagar & Pune Railway Station', 'Viman Nagar & Kharadi IT SEZ', 'Kothrud, Baner & Wakad', 'Magarpatta Cybercity'],
    routeVia: 'NH 48 via Ghodbunder Road, Navi Mumbai (Turbhe/Kalamboli), and the Mumbai-Pune Expressway (Yashwantrao Chavan Expressway)',
    tollParkingPolicy: 'Mumbai-Pune Expressway toll and municipal toll plazas are billed at actuals or quoted all-inclusive.'
  }
];

// Helper to determine specific related routes for smart internal linking
function getRelatedSlugs(originId, destId) {
  const allDestIds = approvedDestinations.map(d => d.id);
  const otherDestsForSameOrigin = allDestIds
    .filter(d => d !== destId)
    .slice(0, 3)
    .map(d => `${originId}-to-${d}`);

  const otherOriginsForSameDest = approvedOrigins
    .map(o => o.id)
    .filter(o => o !== originId)
    .slice(0, 3)
    .map(o => `${o}-to-${destId}`);

  return [...otherDestsForSameOrigin, ...otherOriginsForSameDest];
}

// Build 48 unique routes
export const routeInventory = [
  // 1. Mumbai Airport (6 routes)
  { originId: 'vapi', destId: 'mumbai-airport' },
  { originId: 'bhilad', destId: 'mumbai-airport' },
  { originId: 'daman', destId: 'mumbai-airport' },
  { originId: 'silvassa', destId: 'mumbai-airport' },
  { originId: 'valsad', destId: 'mumbai-airport' },
  { originId: 'umbergaon', destId: 'mumbai-airport' },

  // 2. Surat (6 routes)
  { originId: 'vapi', destId: 'surat' },
  { originId: 'bhilad', destId: 'surat' },
  { originId: 'daman', destId: 'surat' },
  { originId: 'silvassa', destId: 'surat' },
  { originId: 'valsad', destId: 'surat' },
  { originId: 'umbergaon', destId: 'surat' },

  // 3. Ahmedabad (6 routes, including approved Bhilad)
  { originId: 'vapi', destId: 'ahmedabad' },
  { originId: 'bhilad', destId: 'ahmedabad' },
  { originId: 'daman', destId: 'ahmedabad' },
  { originId: 'silvassa', destId: 'ahmedabad' },
  { originId: 'valsad', destId: 'ahmedabad' },
  { originId: 'umbergaon', destId: 'ahmedabad' },

  // 4. Igatpuri (5 routes)
  { originId: 'vapi', destId: 'igatpuri' },
  { originId: 'daman', destId: 'igatpuri' },
  { originId: 'silvassa', destId: 'igatpuri' },
  { originId: 'valsad', destId: 'igatpuri' },
  { originId: 'umbergaon', destId: 'igatpuri' },

  // 5. Malshej Ghat (5 routes)
  { originId: 'vapi', destId: 'malshej-ghat' },
  { originId: 'daman', destId: 'malshej-ghat' },
  { originId: 'silvassa', destId: 'malshej-ghat' },
  { originId: 'valsad', destId: 'malshej-ghat' },
  { originId: 'umbergaon', destId: 'malshej-ghat' },

  // 6. Kalu Waterfall (5 routes)
  { originId: 'vapi', destId: 'kalu-waterfall' },
  { originId: 'daman', destId: 'kalu-waterfall' },
  { originId: 'silvassa', destId: 'kalu-waterfall' },
  { originId: 'valsad', destId: 'kalu-waterfall' },
  { originId: 'umbergaon', destId: 'kalu-waterfall' },

  // 7. Nashik (5 routes)
  { originId: 'vapi', destId: 'nashik' },
  { originId: 'daman', destId: 'nashik' },
  { originId: 'silvassa', destId: 'nashik' },
  { originId: 'valsad', destId: 'nashik' },
  { originId: 'umbergaon', destId: 'nashik' },

  // 8. Vadodara (5 routes)
  { originId: 'vapi', destId: 'vadodara' },
  { originId: 'daman', destId: 'vadodara' },
  { originId: 'silvassa', destId: 'vadodara' },
  { originId: 'valsad', destId: 'vadodara' },
  { originId: 'umbergaon', destId: 'vadodara' },

  // 9. Pune (5 routes)
  { originId: 'vapi', destId: 'pune' },
  { originId: 'daman', destId: 'pune' },
  { originId: 'silvassa', destId: 'pune' },
  { originId: 'valsad', destId: 'pune' },
  { originId: 'umbergaon', destId: 'pune' },
].map(({ originId, destId }) => {
  const origin = approvedOrigins.find(o => o.id === originId);
  const dest = approvedDestinations.find(d => d.id === destId);
  const slug = `${originId}-to-${destId}`;

  // Dedicated factual introductions tailored to route context
  let intro = '';
  if (dest.id === 'mumbai-airport') {
    intro = `Plan your private airport transfer from ${origin.name} (${origin.district}, ${origin.state}) directly to Mumbai Chhatrapati Shivaji Maharaj International Airport (BOM Terminal 1 or Terminal 2). Trishul Tours & Travels provides 24/7 flight-timed departures with doorstep pickups across ${origin.hubs.slice(0, 3).join(', ')}. Enjoy a dedicated AC cab with zero shared passengers, ample boot luggage capacity, and an experienced highway driver navigating NH 48 smoothly.`;
  } else if (dest.id === 'surat') {
    intro = `Book a clean, private one-way or round-trip taxi from ${origin.name} to Surat for business meetings, airport flights at Surat Airport (STV), textile shopping, or hospital visits. Traveling along the 6-lane NH 48 corridor, our chauffeurs offer doorstep pickups from ${origin.name} with direct drop-offs at Varachha, Ring Road, Adajan, or Hazira industrial belt without double return charges for one-way rides.`;
  } else if (dest.id === 'ahmedabad') {
    intro = `Travel with complete peace of mind from ${origin.name} to Ahmedabad, Gandhinagar, or Sardar Vallabhbhai Patel International Airport (AMD). Whether you require a comfortable corporate sedan for GIFT City or a spacious Ertiga / Innova Crysta for family trips, our intercity outstation cabs provide punctual pickups, vetted drivers, and transparent billing for one-way and multi-day round trips.`;
  } else if (dest.id === 'igatpuri') {
    intro = `Escape into the misty hills of the Western Ghats with a private outstation cab from ${origin.name} to Igatpuri. Ideal for attendees of the Dhamma Giri Vipassana International Academy, weekend resort getaways, or nature photography tours around Bhavali Dam and Camel Valley. Enjoy a peaceful journey with sanitized vehicles and drivers familiar with scenic mountain routes.`;
  } else if (dest.id === 'malshej-ghat') {
    intro = `Experience the dramatic monsoonal beauty and cascading waterfalls of Malshej Ghat with a reliable private cab from ${origin.name}. Ideal for bird watchers, family day excursions, and nature lovers exploring Pimpalgaon Joga Dam and mountain cliffs. Book a comfortable SUV or sedan with complete flexibility for scenic viewpoints along the route.`;
  } else if (dest.id === 'kalu-waterfall') {
    intro = `Embark on an adventure trek to Kalu Waterfall in the rugged Malshej Ghat region with a direct private cab from ${origin.name}. Our drivers pick you up from your doorstep in ${origin.name} and navigate directly to the Khireshwar / Thitabi trekking base camp, waiting safely while your group enjoys the hike, ensuring hassle-free round-trip transportation.`;
  } else if (dest.id === 'nashik') {
    intro = `Book your intercity taxi from ${origin.name} to Nashik for Trimbakeshwar Shiva Jyotirlinga darshan, vineyard tours at Sula, or commercial visits to Satpur and Ambad MIDC. We offer sanitized sedans, spacious Ertiga MPVs, and Innova Crysta SUVs with seasoned drivers who know the ghat roads and highway routes intimately.`;
  } else if (dest.id === 'vadodara') {
    intro = `Book a prompt and dependable private taxi from ${origin.name} to Vadodara (Baroda) for corporate visits to Makarpura GIDC, flights from Vadodara Airport (BDQ), or visits to heritage sites like Laxmi Vilas Palace. Travel along the well-connected NH 48 highway with dedicated drivers and clear, transparent outstation billing.`;
  } else if (dest.id === 'pune') {
    intro = `Reserve your private intercity cab from ${origin.name} to Pune covering Hinjewadi IT Park, Pune Airport (PNQ), Shivaji Nagar, or residential suburbs. Skip crowded public transport and travel comfortably via NH 48 and the Mumbai-Pune Expressway with door-to-door convenience, flexible rest stops, and transparent one-way and round-trip pricing.`;
  }

  // 4 Specific FAQs per route
  const faqs = [
    {
      q: `How do I book a private taxi from ${origin.name} to ${dest.name}?`,
      a: `You can request an instant quote by selecting your travel date and vehicle on our booking form or by sending a quick WhatsApp message to +91 83203 42657. Our operations team verifies vehicle availability and confirms your booking with driver details.`
    },
    {
      q: `Are one-way taxi options available between ${origin.name} and ${dest.name}?`,
      a: `Yes, Trishul Tours & Travels provides genuine one-way taxi service from ${origin.name} to ${dest.name}. For one-way journeys, you only pay for the one-way route without having to pay unnecessary return fare charges.`
    },
    {
      q: `Which vehicle categories are available for the ${origin.name} to ${dest.name} trip?`,
      a: `We maintain a well-serviced fleet including 4-seater sedans (Swift Dzire, Hyundai Aura), 6-seater MPVs (Maruti Ertiga), premium 7-seater SUVs (Toyota Innova Crysta), and 17-seater Force Travellers for group travel. All vehicles feature air-conditioning and commercial passenger permits.`
    },
    {
      q: `How are highway tolls and parking charges handled on the ${origin.name} to ${dest.name} route?`,
      a: `Highway toll plazas and destination parking charges can either be paid directly at actuals by the passenger or quoted as a transparent, all-inclusive package upfront before your ride begins.`
    }
  ];

  return {
    slug,
    originId,
    destId,
    originName: origin.name,
    originDistrict: origin.district,
    originState: origin.state,
    destinationName: dest.name,
    destinationFullName: dest.fullName,
    destinationCity: dest.city,
    category: dest.category,
    routeVia: dest.routeVia,
    tollParkingPolicy: dest.tollParkingPolicy,
    pickupHubs: origin.hubs,
    dropPoints: dest.dropPoints,
    seoTitle: `${origin.name} to ${dest.name} Taxi & Cab | Trishul Tours`,
    seoDescription: `Book a reliable taxi from ${origin.name} to ${dest.name} with Trishul Tours & Travels. Explore one-way and round-trip options, available vehicles and request your fare on WhatsApp.`,
    h1: `${origin.name} to ${dest.name} Taxi & Cab Service`,
    intro,
    highlights: [
      `Dedicated private vehicle — zero shared passengers`,
      `Doorstep pickup anywhere across ${origin.name} (${origin.hubs.slice(0, 3).join(', ')})`,
      `Direct drop at ${dest.dropPoints[0]} and surrounding locations`,
      `Route transit via ${dest.routeVia}`,
      `Experienced, verified drivers familiar with highway and city routes`,
      `Clean, sanitized fleet with working AC and luggage space`,
      `24/7 customer support and flight tracking for airport transfers`
    ],
    tripTypes: ['One Way Trip', 'Round / Return Trip'],
    vehicleOptions: [
      { name: 'Swift Dzire / Hyundai Aura', category: 'Sedan', seats: 4, luggage: '2 Large Bags', bestFor: 'Solo travelers, couples, airport drops' },
      { name: 'Maruti Ertiga', category: 'MUV / MPV', seats: 6, luggage: '3 Bags', bestFor: 'Small families, airport luggage, comfortable highway rides' },
      { name: 'Toyota Innova Crysta', category: 'Premium SUV', seats: 7, luggage: '4 Bags', bestFor: 'Executive travel, long outstation comfort, luxury family trips' },
      { name: 'Force Traveller', category: '17-Seater Van', seats: 17, luggage: '10 Bags', bestFor: 'Group tours, pilgrimages, family functions, corporate retreats' }
    ],
    faqs,
    relatedRoutes: getRelatedSlugs(originId, destId),
    active: true,
    indexed: true,
    lastModified: '2026-10-19'
  };
});

// Lookup map for instant slug retrieval
export const routeMap = new Map(routeInventory.map(r => [r.slug, r]));

export function getRouteBySlug(slug) {
  if (!slug) return null;
  // Normalize slug by removing leading/trailing slashes
  const cleanSlug = slug.replace(/^\/+|\/+$/g, '').replace(/^routes\//, '');
  return routeMap.get(cleanSlug) || null;
}

export function getAllApprovedRoutes() {
  return routeInventory.filter(r => r.active !== false);
}

export function getAllIndexableRoutes() {
  return routeInventory.filter(r => r.active !== false && r.indexed !== false);
}
